import {PIXI, Ease} from '@colonist/pixi'
import {VoteView} from '../../ui_canvas_engine/VoteView'
import {UIGameManager} from '../UIGameManager'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {VoteState} from '@colonist/game-state-types'
import {UIGameComponentZIndex} from '../UIGameComponentZIndex'
import {setGlobalIsLogVisible, setGlobalIsChatVisible} from '@colonist/ui-game'

export abstract class UIGameVoteController implements UIGameMechanic {
    protected readonly TIME = {
        VOTE_ARRIVE: 500,
    }

    protected readonly uiGameManager: UIGameManager

    protected readonly votes: PIXI.Container
    protected readonly ease: Ease
    protected _activeVote?: VoteState | undefined
    protected voteView?: VoteView | undefined

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        const canvas = uiGameManager.canvasController
        this.ease = new Ease({useRaf: false})
        this.votes = new PIXI.Container()
        this.votes.zIndex = UIGameComponentZIndex.VotePopups
        canvas.app.stage.addChild(this.votes)
    }

    get activeVote(): VoteState | undefined {
        return this._activeVote
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.VoteReceived: this.updateVote(data); break
            default: break
        }
    }

    private endVote() {
        this.hideVoteView()
        this._activeVote = undefined
    }

    protected hideVoteView() {
        const chatController = this.uiGameManager.chatController
        chatController?.setLogContainerVisibility(true)
        chatController?.setChatContainerVisibility(true)
        setGlobalIsLogVisible(true)
        setGlobalIsChatVisible(true)
        this.votes.removeChildren()
        this.voteView?.destroy()
        this.voteView = undefined
    }

    protected abstract showVoteView()

    private updateVote(vote: VoteState) {
        if(this._activeVote == undefined) {
            this.updateNewVote(vote)
            return
        }

        if(this._activeVote.id === vote.id) this.updateActiveVote(vote)
    }

    private updateNewVote(vote: VoteState) {
        if(this._activeVote != undefined) return
        this._activeVote = vote
        this.updateActiveVote(vote)
    }

    private updateActiveVote(vote: VoteState) {
        if(vote.id != this._activeVote?.id) return
        if(vote.done) {
            this.endVote()
            return
        }

        this._activeVote = vote

        const allVotes = [...vote.acceptedVotes, ...vote.declinedVotes]
        const hasPlayerAlreadyVoted = ArrayUtils.elementInArray(allVotes, this.uiGameManager.gameController.myColor)
        const shouldShowVoteView = !hasPlayerAlreadyVoted && this.voteView == undefined
        if(shouldShowVoteView) this.showVoteView()

        this.voteView?.loadDataIntoPlayerList(this._activeVote)
    }

    castVote(accepted: boolean, vote: VoteState | undefined = this.activeVote) {
        if(vote == undefined) return
        this.uiGameManager.socketGameSend.clickedVote(vote.id, accepted)
    }
}
